module.exports = __webpack_public_path__ + "img/R@2x.e6325636.jpg";